import React, {useCallback, useEffect} from "react";
import Select from "react-select";

const timeZones = Intl.supportedValuesOf('timeZone')
console.log("timezone length",timeZones.length)

const options = timeZones.map(timeZone => ({
  value: timeZone,
  label: timeZone
}));

export const TimeZoneSelect = ({ value, onChange, overrideProps={} }) => {
  const handleChange = useCallback(selectedOption => {
    onChange(selectedOption.value);
  }, [onChange]);

  useEffect(() => {
    if (value === undefined) {
      onChange("America/New_York");
    }
  }, [value, onChange]);

  const selectedOption = options.find(option => option.value === value);

  return (
    <Select
      options={options}
      onChange={handleChange}
      value={selectedOption}
      defaultValue={{value: "America/New_York", label: "America/New_York"}}
      {...overrideProps}
    />
  );
};


